import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface TaxHeadsState {
  taxHeads: any
  taxHead: any
  error: any
}

export const useTaxHeadsStore = defineStore('taxHeads', {
  state: (): TaxHeadsState => ({
    taxHeads: null,
    taxHead: null,
    error: null,
  }),

  getters: {
    getTaxHeads: (state) => state.taxHeads,
    getTaxHead: (state) => state.taxHead,
    getTaxHeadError: (state) => state.error,
  },

  actions: {
    async fetchTaxHeads() {
      try {
        const response = await api().get('configuration/tax-head/all')
        this.taxHeads = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async createTaxHead(data: any) {
      try {
        const response = await api().post('configuration/tax-head/create', data)
        this.taxHead = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },

    async updateTaxHead(data: any) {
      try {
        const response = await api().post('configuration/tax-head/by-id?taxHeadId=' + data.id, data)
        this.taxHead = response.data
      } catch (error: any) {
        this.error = error.response?.data
      }
    },
  },
})
